/** Fonts are a closed catalogue: no remote font URL or arbitrary CSS is accepted. */
export const fontFamilies = ["Manrope", "Inter", "DM Sans", "Playfair Display", "Arial", "Georgia"] as const;
export type FontFamily = typeof fontFamilies[number];
export const surfaceEffects = ["flat", "shadow", "glass", "bordered", "soft"] as const;
export const motionEffects = ["none", "subtle", "fade", "slide", "float"] as const;
